/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_speed_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. A nautical mile is 1,852 meters, versus 1,609.344 meters for a standard (statute) mile — about 15% longer. That's why 1 knot (1.852 km/h) is a slightly higher speed than 1 mph (1.609 km/h) even though both describe 'one mile per hour' in their respective systems.`)
};

const es_uc_speed_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Una milla náutica es 1,852 metros, versus 1,609.344 metros para una milla regular (estatutaria) — aproximadamente 15% más larga. Por eso 1 nudo (1.852 km/h) es una velocidad ligeramente más alta que 1 mph (1.609 km/h) aunque ambas describan 'una milla por hora' en sus respectivos sistemas.`)
};

const de_uc_speed_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Eine Seemeile sind 1,852 Meter, gegenüber 1,609.344 Metern für eine Standardmeile (statute mile) — etwa 15% länger. Deshalb ist 1 Knoten (1.852 km/h) eine etwas höhere Geschwindigkeit als 1 mph (1.609 km/h), obwohl beide in ihrem jeweiligen System 'eine Meile pro Stunde' beschreiben.`)
};

const nl_uc_speed_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Een zeemijl is 1.852 meter, versus 1.609.344 meter voor een standaard (wet) mijl — ongeveer 15% langer. Daarom is 1 knoop (1.852 km/u) een iets hogere snelheid dan 1 mph (1.609 km/u) ook al beschrijven beide 'één mijl per uur' in hun respectieve stelsels.`)
};

const fr_uc_speed_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Un mille nautique est 1 852 mètres, contre 1 609,344 mètres pour un mile standard (statute mile) — environ 15 % plus long. C'est pourquoi 1 nœud (1,852 km/h) est une vitesse légèrement plus rapide que 1 mph (1,609 km/h) même si tous les deux décrivent 'un mile par heure' dans leurs systèmes respectifs.`)
};

const it_uc_speed_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Un miglio nautico è 1.852 metri, rispetto a 1.609.344 metri per un miglio standard (statuario) — circa il 15% più lungo. Ecco perché 1 nodo (1,852 km/h) è una velocità leggermente più alta di 1 mph (1,609 km/h) anche se entrambi descrivono 'un miglio all'ora' nei rispettivi sistemi.`)
};

const pt_br2_uc_speed_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Uma milha náutica é 1.852 metros, versus 1.609.344 metros para uma milha (estatutária) padrão — cerca de 15% mais longa. É por isso que 1 nó (1.852 km/h) é uma velocidade ligeiramente mais alta do que 1 mph (1.609 km/h) mesmo que ambas descrevam 'uma milha por hora' em seus respectivos sistemas.`)
};

const pt_uc_speed_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Uma milha náutica é 1852 metros, versus 1609,344 metros para uma milha padrão (estátuto) — cerca de 15% mais longa. É por isto que 1 nó (1,852 km/h) é uma velocidade ligeiramente superior a 1 mph (1,609 km/h) mesmo que ambos descrevam 'uma milha por hora' nos seus respectivos sistemas.`)
};

const ja_uc_speed_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。海里は1,852メートルで、標準(法定)マイル 1,609.344メートルと比較して — 約15%長いです。したがって1ノット(1.852 km/h)は1 mph(1.609 km/h)よりわずかに高い速度で、両方が「1時間あたり1マイル」を説明していても、それぞれのシステムで。`)
};

const zh_uc_speed_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_speed_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_speed_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_speed_faq3_a", locale)
	if (locale === "en") return en_uc_speed_faq3_a(inputs)
	if (locale === "es") return es_uc_speed_faq3_a(inputs)
	if (locale === "de") return de_uc_speed_faq3_a(inputs)
	if (locale === "nl") return nl_uc_speed_faq3_a(inputs)
	if (locale === "fr") return fr_uc_speed_faq3_a(inputs)
	if (locale === "it") return it_uc_speed_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_speed_faq3_a(inputs)
	if (locale === "pt") return pt_uc_speed_faq3_a(inputs)
	if (locale === "ja") return ja_uc_speed_faq3_a(inputs)
	return zh_uc_speed_faq3_a(inputs)
};